import QuestionComments from './QuestionComments';

export default QuestionComments;
